import {getLoginKennung, setLoginStatus} from '../../libraries/login-status';
import '../../libraries/turnstile-container';

class LoginFormular extends HTMLElement {
    connectedCallback() {
        this.kennung = this.querySelector('[name=kennung]');
        this.setupObserverIframeResize();
        this.loginFormularVorbereiten();
        this.addPasswortToggleHandler();

        this.setupValidation({
            inputId: 'email-input',
            containerClass: 'email-error-container',
            getTemplateId: this.getEmailErrorTemplateId.bind(this),
        });
        this.setupValidation({
            inputId: 'password-input',
            containerClass: 'password-error-container',
            getTemplateId: () => 'error-password-too-short',
        });

        if (window !== window.parent) {
            window.addEventListener('message', (event) => this.onParentFormSubmit(event));
        } else {
            this.triggerScreenReaderErrorMessage();
            this.addFormSubmitHandler();
            this.addJsClass();
            this.checkCookies();
            this.addTurnstileSuccessListener();
        }
    }

    checkCookies() {
        if (!navigator.cookieEnabled) {
            this.blendeCookieHinweisEin();
        }
    }
    
    blendeCookieHinweisEin() {
        const template = this.querySelector('[data-template=cookie-fehler]').innerText;
        const fehlerWrapper = this.querySelector('.box-fehler');
        fehlerWrapper.insertAdjacentHTML('afterend', template);
    }

    async loginFormularVorbereiten() {
        try {
            //TODO: Sobald Login nur über iFrame läuft muss der else-Zweig entfernt werden

            if (window !== window.parent){
                //Localstorage ist nicht mehr via iFrame erreichbar, weswegen wir über postMessages gehen müssen
                const kennung = await this.getLocalStorageItem('kim.login.loginUsername');
                if (this.kennung.value === "") {
                    this.kennung.value = kennung;
                }
                this.setLocalStorageItem('kim.login.loginUsername', kennung || '');
                this.setLocalStorageItem('kim.login.showAsLoggedIn', 'false');
            } else {
                // normaler Login-Pfad via direkten LocalStorage-Zugriff über login-status.js

                const kennung = getLoginKennung();
                if (this.kennung.value === "") {
                    this.kennung.value = kennung;
                }
                setLoginStatus(false, kennung);
                kim.updateLoginLinks()
            }

        } catch(e) {
            console.error('[localStorage] Fehler:', e)
        }
    }
    
    addFormSubmitHandler() {
        this.addEventListener('submit', (event) => {this.submitForm(event);});
    }

    submitForm() {
    }

    addPasswortToggleHandler() {
        const toggleButton = this.querySelector('[interaction=passwort-toggle]');
        const input = this.querySelector('.input-passwort');

        toggleButton.addEventListener('click', (event) => {
            event.preventDefault();

            const isVisible = input.getAttribute('type') === 'text';
            input.setAttribute('type', isVisible ? 'password' : 'text');

            toggleButton.setAttribute('aria-pressed', String(!isVisible));
            toggleButton.setAttribute('aria-label', isVisible ? 'Passwort anzeigen' : 'Passwort verbergen');

            toggleButton.classList.remove('button-eye-open', 'button-eye-closed');
            toggleButton.classList.add(isVisible ? 'button-eye-open' : 'button-eye-closed');
        });
    }

    triggerScreenReaderErrorMessage () {
        const generalErrorText = document.querySelector('[data-general-error-message]');
        const emailErrorText = document.querySelector('[data-email-error-message]');
        const passwordErrorText = document.querySelector('[data-password-error-message]');

        const generalLiveRegion = document.getElementById('form-general-error');
        const emailLiveRegion = document.getElementById('form-email-error');
        const passwordLiveRegion = document.getElementById('form-password-error');

        const updateLiveRegion = (region, message) => {
            if (region && message) {
                region.textContent = '';
                setTimeout(() => {
                    region.textContent = message.textContent;
                    region.focus();
                }, 30);
            }
        };

        updateLiveRegion(generalLiveRegion, generalErrorText);
        updateLiveRegion(emailLiveRegion, emailErrorText);
        updateLiveRegion(passwordLiveRegion, passwordErrorText);
    }

    setupValidation({ inputId, containerClass, getTemplateId }) {
        const input = this.querySelector(`#${inputId}`);
        const errorContainer = this.querySelector(`.${containerClass}`);
        if (!input || !errorContainer || typeof getTemplateId !== 'function') return;

        let currentTemplateId = null;

        const showError = () => {
            if (!input.value.trim()) return;

            const templateId = getTemplateId(input);
            if (!templateId || templateId === currentTemplateId) return;

            const template = this.querySelector(`#${templateId}`);
            if (!template) return;

            const content = template.content.cloneNode(true);
            const errorTextId = `${templateId}-text`;

            errorContainer.replaceChildren(content);
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', errorTextId);
            currentTemplateId = templateId;
        };

        const clearError = () => {
            if (currentTemplateId !== null) {
                errorContainer.replaceChildren();
                input.setAttribute('aria-invalid', 'false');
                input.removeAttribute('aria-describedby');
                currentTemplateId = null;
            }
        };

        input.addEventListener('blur', () => {
            if (!input.value.trim()) {
                clearError();
            } else if (input.checkValidity()) {
                clearError();
            } else {
                showError();
            }
        });

        input.addEventListener('input', () => {
            clearError();
        });

        input.addEventListener('invalid', (e) => {
            e.preventDefault();
            showError();
        });
    }

    getEmailErrorTemplateId(input) {
        const emailAddress = input.value.trim();

        if (!emailAddress) return 'error-email-required';
        if (!emailAddress.includes('@')) return 'error-email-missing-at';

        const parts = emailAddress.split('@');
        if (parts.length !== 2) return 'error-email-invalid';

        const [local, domain] = parts;

        if (!local) return 'error-email-missing-local';
        if (!domain) return 'error-email-missing-domain';

        if (input.validity.typeMismatch) return 'error-email-invalid';

        return null;
    }

    addJsClass() {
        this.querySelector('form').classList.add('js');
    }

    addTurnstileSuccessListener() {
        const turnstileContainer = this.querySelector('turnstile-container');
        if (!turnstileContainer) return;
        turnstileContainer.addEventListener("turnstile.success", () => {this.turnstileSuccess();});
    }

    turnstileSuccess(){
        this.querySelector('[interaction=button-submit]').disabled = false;
    }

    onParentFormSubmit(event) {
        if (event.source !== window.parent) return;
        if (event.data?.type !== 'form:submit') return;
        const form = this.querySelector('form');
        let input = form.querySelector('input[name="cf-turnstile-response"]');
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'cf-turnstile-response';
            form.appendChild(input);
        }
        input.value = event.data.token ?? '';
        form.submit();
    }

    setupObserverIframeResize(){
        if (window === window.parent) return;

        const sendHeight = () => {
            window.parent.postMessage(
                { type: 'loginIframeResize', height: document.documentElement.scrollHeight },
                '*' //TODO: Mandantenspezifische Origin angeben
            )
        };

        new ResizeObserver(sendHeight).observe(document.body);
        sendHeight();
    }

    async getLocalStorageItem(key) {
        //iFrame schickt Anfrage an Parent und wartet auf Antwort
        return new Promise((resolve) => {
            //Zufällig ID für loginUsername und showAsLoggedIn, damit unterschieden werden kann welcher Wert vom Storage kommt
            const requestId = Math.random().toString(36).slice(2,10);
            
            const timeout = setTimeout(() => {
                window.removeEventListener('message', handler);
                resolve(null);
            }, 3000);

            //Lauscher auf die eingehende Nachrichten
            const handler = (event) => {
                if (event.data?.type === 'localStorage:response' && event.data.requestId === requestId) {
                    clearTimeout(timeout);
                    window.removeEventListener('message', handler);
                    resolve(event.data.value);
                }
            };
            window.addEventListener('message', handler);
            // TODO: Mandantenspezifische Origin angeben statt '*'
            window.parent.postMessage({type: 'localStorage:get', key, requestId }, '*');
        });
    }

    setLocalStorageItem(key, value) {
        // TODO: Mandantenspezifische Origin angeben statt '*'
        window.parent.postMessage({type: 'localStorage:set', key, value: String(value)}, '*');
    }
}

customElements.define('login-form', LoginFormular);